import { useState } from 'react';
import Modal from 'react-modal';
import { ModalContext } from '../../contexts/ModalContext';
import { CrossSvg } from '../Icons/svgIcons';

Modal.setAppElement('#root') 

export function ModalProvider({ children }) {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const openModal = (content) => {
        setModalContent(content);
        setModalIsOpen(true);
    }

    const closeModal = () => {
        setModalIsOpen(false);
    }

    return (
        <ModalContext.Provider value={{ openModal, closeModal }}>
            {children}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Modal"
                className="w-full h-full flex justify-center items-center z-10 bg-white bg-opacity-80"
            >
                {modalContent}
                <button className="absolute z-20 top-8 right-4 border-gray-200" onClick={closeModal}>
                    <CrossSvg/>
                </button>
            </Modal>
        </ModalContext.Provider>
    );
}